import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import { equipmentSectionInitialValues } from '../../Equipment/utils/form';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.BUSINESS_OPERATIONS}.${BUSINESS_TOOL_SUB_SECTIONS.BUSINESS_OPERATIONS.TECHNOLOGICAL_PROCESS}` as const;

export const STAGES_NAMES = {
  STAGE: 'stage'
} as const;

export interface IStages {
  [STAGES_NAMES.STAGE]: string;
}

export const stagesValues = {
  [STAGES_NAMES.STAGE]: '',
}

export const TECHNOLOGICAL_PROCESS_NAMES = {
  TECHNOLOGY: 'technology',
  QUALITIES: 'qualities',
  STAGES: 'stages',
  COMPETING_TECHNOLOGY: 'competingTechnology',
} as const;

export interface ITechnologicalProcess {
  [TECHNOLOGICAL_PROCESS_NAMES.TECHNOLOGY]: string;
  [TECHNOLOGICAL_PROCESS_NAMES.QUALITIES]: string;
  [TECHNOLOGICAL_PROCESS_NAMES.STAGES]: IStages[];
  [TECHNOLOGICAL_PROCESS_NAMES.COMPETING_TECHNOLOGY]: string;
}

export const technologicalProcessInitialValues = {
  [TECHNOLOGICAL_PROCESS_NAMES.TECHNOLOGY]: '',
  [TECHNOLOGICAL_PROCESS_NAMES.QUALITIES]: '',
  [TECHNOLOGICAL_PROCESS_NAMES.STAGES]: [stagesValues],
  [TECHNOLOGICAL_PROCESS_NAMES.COMPETING_TECHNOLOGY]: '',
};

export { equipmentSectionInitialValues };